// extracted by mini-css-extract-plugin
export var body = "search-module--body--VfkDv";
export var circleArrow = "search-module--circleArrow--9uuqG";
export var closeButton = "search-module--closeButton--NZnVL";
export var emptyState = "search-module--emptyState--PQNmy";
export var hit = "search-module--hit--Dhx1I";
export var imageContainer = "search-module--imageContainer--Xnvmt";
export var input = "search-module--input--mDfSi";
export var mobileSearch = "search-module--mobileSearch--zUNRs";
export var sbShowMain = "search-module--sb-show-main--XjmBn";
export var search = "search-module--search--LWHXx";
export var type = "search-module--type--MPPyX";